export const company = {
    nameAr: 'شركة القصواء الكبرى للمقاولات العامة والاستثمار العقاري',
    shortNameAr: 'شركة القصواء الكبرى',
    nameEn: 'ALQASWA ALKOBRA',
    mark: 'QK',
    taglineAr: 'نبني المستقبل، ونصنع القيمة',
    taglineEn: 'Building tomorrow. Creating value.',
    coordinates: {
        lat: 32.8209172,
        lng: 13.2196262,
    },
    googleMapsUrl: 'https://maps.app.goo.gl/i8SW2fmdJ2AF3ss97?g_st=awb',
    websiteUrl: 'https://qk-alkaswa.ly/',
    phone: '0917333233',
    email: 'info@qk-alkaswa.ly',
    addressAr: 'طرابلس، ليبيا',
    addressEn: 'Tripoli, Libya',
};
